import{styled as n}from"@mui/material";var a=n("div")(({theme:n})=>`\n  display: flex;\n  gap: ${n.spacing(2)};\n\n  & > * {\n    flex: 1;\n    min-width: 0;\n  }\n`);export{a as Row};
//# sourceMappingURL=styled.js.map